export enum AdCampaign {
  'facebook' = 'facebook',
  'google' = 'google',
}

export interface SignUpData {
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  acceptedTerms: boolean;
  password: string;
  passwordConfirm: string;
}
